<template>
  <div :class="{'has-logo':showLogo}">
    <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- <sidebar-item v-for="(route,index) in $router.options.routes" :key="index" :item="route" :base-path="route.path" /> -->
        <div @mouseleave="closeSideBar">
          <sidebar-item @mouseEnterOpenSideBar="openSideBar" v-for="(route,index) in routerComponents" :key="index" :item="route" :base-path="route.path" />
        </div>
      <!-- <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in permission_routes" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu> -->
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  data() {
    return {
      routerComponents: []
    }
  },
  mounted() {
   
    if(this.env=== 'dev') {
      this.routerComponents = this.$router.options.routes
    } else {
       this.routerComponents = this.$store.state.user.routerComponents
    }
  },
  watch: {
    '$store.state.user.routerComponents': {
      handler() {
        if(this.env=== 'dev') {
      this.routerComponents = this.$router.options.routes
    } else {
       this.routerComponents = this.$store.state.user.routerComponents
    }
      }
    }
  },
  // components: { SidebarItem, Logo },
   components: { SidebarItem },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
  },
  methods: {
    openSideBar() {
      
      if(!this.$store.state.app.sidebar.opened) {
        this.$store.dispatch('app/openSideBarByMouse')
      }
    },
    closeSideBar() {
       if(this.$store.state.app.sidebar.opened) {
        this.$store.dispatch('app/closeSideBarByMouse')
      }
    },
  },
}
</script>
